export class ExchangeResponse {
  custom_token?: string;
  tenant_id?: string;
}
